import React, {useContext, useMemo, useState, useEffect} from "react";
import { UserContext } from '../Context/UserContext';
import "../styles/pitcherTrendsTable.css"
import {useNavigate} from "react-router-dom"

function BadPitcherMatchupRatingTrendsTable({ratingTimeframe}) {
    const {state, dispatch} = useContext(UserContext);
    //console.log('state', state)
    const navigate = useNavigate()
    const [sortDirection, setSortDirection] = useState(false)
    const [sortState, setSortState] = useState("matchupRating")
    const [dataTimeframe, setDataTimeframe] = useState("ThreeYear")

    useEffect(() => {
        setDataTimeframe(ratingTimeframe ? "CurrentSeason" : "ThreeYear")
    }, [ratingTimeframe])
    //console.log('datatimeframe', dataTimeframe)

    const trendsByTimeFrame = state?.[`badPitcherMatchupRatingTrends${dataTimeframe}`]
    const relDailyPitcherByTimeFrame = state?.[`dailyPitcher${dataTimeframe}Stats`]

    function getMatchupRating(pitID) {
        const rel_pitcher = relDailyPitcherByTimeFrame?.find((stat) => stat.pitcher_id === pitID)
        //console.log('rel_pitcher', rel_pitcher)
        const matchupRatingStyles = {
            backgroundColor: (rel_pitcher?.pitcher_matchup_rating_thirty_percent >= 6.4 ? 'lightpink' : '')
        }

        return {ratingStyle: matchupRatingStyles, rating: rel_pitcher.pitcher_matchup_rating_thirty_percent.toFixed(3)}
    }

    const pitcherRatings = useMemo(() => {
        return trendsByTimeFrame.map((trend) => ({
            id: trend.id,
            pitcherID: trend.pitcher_id,
            name: trend.pitcher_name,
            team: trend.team,
            matchupRating: getMatchupRating(trend.pitcher_id).rating,
            numberGames: trend.num_games_sample_size,
            pctFiveOrLessIP: trend.pct_five_or_less_ip_mr_category,
            pctSixOrLessIP: trend.pct_six_or_less_ip_mr_category,
            pctFourOrLessK: trend.pct_four_or_less_strikeouts_mr_category,
            pctFiveOrLessK: trend.pct_five_or_less_strikeouts_mr_category,
            pctSixOrLessK: trend.pct_six_or_less_strikeouts_mr_category,
            pctSevenorLessK: trend.pct_seven_or_less_strikeouts_mr_category,
            pctEightorLessK: trend.pct_eight_or_less_strikeouts_mr_category,
            pctTwoPlusER: trend.pct_two_plus_earned_runs_mr_category,
            pctThreePlusER: trend.pct_three_plus_earned_runs_mr_category,
            pctFourPlusER: trend.pct_four_plus_earned_runs_mr_category,
            pctFourPlusHits: trend.pct_four_plus_hits_mr_category,
            pctFivePlusHits: trend.pct_five_plus_hits_mr_category,
            pctSixPlusHits: trend.pct_six_plus_hits_mr_category,
            PctOnePlusWalks: trend.pct_one_plus_walks_mr_category,
            pctTwoPlusWalks: trend.pct_two_plus_walks_mr_category,
            pctOnePlusHR: trend.pct_one_plus_home_run_allowed,
            pctLoss: trend.pct_loss_mr_category,
            backgroundColor: getMatchupRating(trend.pitcher_id).ratingStyle
        }));
    }, [trendsByTimeFrame])

    //console.log(pitcherRatings)
    const [filteredPitchers, setFilteredPitchers] = useState(pitcherRatings)

    useEffect(() => {
        setFilteredPitchers(pitcherRatings)
    }, [pitcherRatings])

    function handleSort(e) {
        //console.log('value', e.target.dataset.sortKey)
        setSortState(e.target.dataset.sortKey)
        setSortDirection((prevDirection) => !prevDirection)
    }

    const sortedTrends = useMemo(() => {
        const sortedStats = [...(filteredPitchers)]?.sort((a, b) => {
            const aValue = a?.[sortState] || "";
            const bValue = b?.[sortState] || "";

            if (typeof aValue === "string" && typeof bValue === "string") {
                return sortDirection 
                    ? aValue.localeCompare(bValue)  // Ascending order for strings
                    : bValue.localeCompare(aValue); // Descending order for strings
            }

            const numA = Number(aValue) || 0;
            const numB = Number(bValue) || 0;
            return sortDirection ? numA - numB : numB - numA;
        });
        //console.log('sortedStats', sortedStats)
        //console.log('sortState', sortState)
        //console.log('sortDirection', sortDirection)
        return sortedStats;
    }, [filteredPitchers, sortDirection, sortState])
   // console.log('sortedTrends', sortedTrends)

    function handleSearch(e) {
        const inputValue = e.target.value.toLowerCase('')
        if (e.target.value === "" || e.target.value === undefined || e.target.value === null) {
            setFilteredPitchers(pitcherRatings)
        }
        else {
            setFilteredPitchers(pitcherRatings.filter((rating) => rating.name.toLowerCase().includes(inputValue)))
        }
    }

    function fetchsinglePitcherData(pitcherID) {
        fetch(`/pitchers/${pitcherID}`)
            .then(res => res.json())
            .then(data => {
                if (data) {
                    dispatch({type: "fetchSinglePitcher", payload: data})
                }
                else {
                    console.error("Error: Pitcher data not found")
                }
            })
    }

    function navigateToPitcherPage(pitchername, pitcherID) {
        state.singlePitcher = []
        const formattedName = pitchername.replace(/ /g, "-")
        fetchsinglePitcherData(pitcherID)
        navigate(`/pitcher/${formattedName}`)
        window.scrollTo(0, 0)
    }

    return (
        <div>
            {trendsByTimeFrame.length === 0 && (<h2 style={{textAlign: "center"}}>No Pitcher Ratings in this category</h2>)}
            {trendsByTimeFrame.length > 0 && (
            <div>
                <div className="searchBar">
                    <label>Search A Pitcher: </label>
                    <input type="text" placeholder="Ex: Shota Imanaga" onChange={handleSearch}></input>
                </div>
                <br />
                <div className="pitcherTrendsContainerTable">
                    <table>
                        <thead>
                            <tr>
                                <th className={sortState === "name" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="name">Name<span>↕️</span></th>
                                <th className={sortState === "team" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="team">Team<span>↕️</span></th>
                                <th className={sortState === "matchupRating" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="matchupRating">Matchup Rating<span>↕️</span></th>
                                <th className={sortState === "numberGames" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="numberGames">Games<span>↕️</span></th>
                                <th className={sortState === "pctFiveOrLessIP" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctFiveOrLessIP">Under 5.5 IP<span>↕️</span></th>
                                <th className={sortState === "pctSixOrLessIP" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctSixOrLessIP">Under 6.5 IP<span>↕️</span></th>
                                <th className={sortState === "pctFourOrLessK" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctFourOrLessK">Under 4.5 K<span>↕️</span></th>
                                <th className={sortState === "pctFiveOrLessK" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctFiveOrLessK">Under 5.5 K<span>↕️</span></th>
                                <th className={sortState === "pctSixOrLessK" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctSixOrLessK">Under 6.5 K<span>↕️</span></th>
                                <th className={sortState === "pctSevenorLessK" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctSevenorLessK">Under 7.5 K<span>↕️</span></th>
                                <th className={sortState === "pctEightorLessK" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctEightorLessK">Under 8.5 K<span>↕️</span></th>
                                <th className={sortState === "pctTwoPlusER" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctTwoPlusER">Over 1.5 ER<span>↕️</span></th>
                                <th className={sortState === "pctThreePlusER" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctThreePlusER">Over 2.5 ER<span>↕️</span></th>
                                <th className={sortState === "pctFourPlusER" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctFourPlusER">Over 3.5 ER<span>↕️</span></th>
                                <th className={sortState === "pctFourPlusHits" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctFourPlusHits">Over 3.5 Hits<span>↕️</span></th>
                                <th className={sortState === "pctFivePlusHits" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctFivePlusHits">Over 4.5 Hits<span>↕️</span></th>
                                <th className={sortState === "pctSixPlusHits" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctSixPlusHits">Over 5.5 Hits<span>↕️</span></th>
                                <th className={sortState === "PctOnePlusWalks" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="PctOnePlusWalks">Over 0.5 Walks<span>↕️</span></th>
                                <th className={sortState === "pctTwoPlusWalks" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctTwoPlusWalks">Over 1.5 Walks<span>↕️</span></th>
                                <th className={sortState === "pctOnePlusHR" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctOnePlusHR">Over 0.5 HR<span>↕️</span></th>
                                <th className={sortState === "pctLoss" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctLoss">Records Loss<span>↕️</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            {sortedTrends.map((trend) => {
                                const teamStyles = {backgroundColor: state.teamColors[trend.team].primary || "transparent"}
                                const five_or_less_ip_styles = {
                                    color: (trend?.pctFiveOrLessIP >= 70.00 ? 'rgba(0, 105, 0)' : (trend?.pctFiveOrLessIP <= 50.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                                }
                                const six_or_less_ip_styles = {
                                    color: (trend?.pctSixOrLessIP >= 70.00 ? 'rgba(0, 105, 0)' : (trend?.pctSixOrLessIP <= 50.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                                }
                                const four_or_less_strikeouts_styles = {
                                    color: (trend?.pctFourOrLessK >= 60.00 ? 'rgba(0, 105, 0)' : (trend?.pctFourOrLessK <= 40.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                                }
                                const five_or_less_strikeouts_styles = {
                                    color: (trend?.pctFiveOrLessK >= 70.00 ? 'rgba(0, 105, 0)' : (trend?.pctFiveOrLessK <= 50.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                                }
                                const six_or_less_strikeouts_styles = {
                                    color: (trend?.pctSixOrLessK >= 75.00 ? 'rgba(0, 105, 0)' : (trend?.pctSixOrLessK <= 50.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                                }
                                const seven_or_less_strikeouts_styles = {
                                    color: (trend?.pctSevenorLessK >= 85.00 ? 'rgba(0, 105, 0)' : (trend?.pctSevenorLessK <= 50.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                                }
                                const eight_or_less_strikeouts_styles = {
                                    color: (trend?.pctEightorLessK >= 85.00 ? 'rgba(0, 105, 0)' : (trend?.pctEightorLessK <= 50.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                                }
                                const two_plus_earned_runs_styles = {
                                    color: (trend?.pctTwoPlusER >= 60.00 ? 'rgba(0, 105, 0)' : (trend?.pctTwoPlusER <= 50.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                                }
                                const three_plus_earned_runs_styles = {
                                    color: (trend?.pctThreePlusER >= 50.00 ? 'rgba(0, 105, 0)' : (trend?.pctThreePlusER <= 40.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                                }
                                const four_plus_earned_runs_styles = {
                                    color: (trend?.pctFourPlusER >= 40.00 ? 'rgba(0, 105, 0)' : (trend?.pctFourPlusER <= 30.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                                }
                                const four_plus_hits_styles = {
                                    color: (trend?.pctFourPlusHits >= 65.00 ? 'rgba(0, 105, 0)' : (trend?.pctFourPlusHits <= 50.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                                }
                                const five_plus_hits_styles = {
                                    color: (trend?.pctFivePlusHits >= 55.00 ? 'rgba(0, 105, 0)' : (trend?.pctFivePlusHits <= 40.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                                }
                                const six_plus_hits_styles = {
                                    color: (trend?.pctSixPlusHits >= 50.00 ? 'rgba(0, 105, 0)' : (trend?.pctSixPlusHits <= 35.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                                }
                                const one_plus_walks_styles = {
                                    color: (trend?.PctOnePlusWalks >= 70.00 ? 'rgba(0, 105, 0)' : (trend?.PctOnePlusWalks <= 50.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                                }
                                const two_plus_walks_styles = {
                                    color: (trend?.pctTwoPlusWalks >= 60.00 ? 'rgba(0, 105, 0)' : (trend?.pctTwoPlusWalks <= 40.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                                }
                                const one_plus_homer_styles = {
                                    color: (trend?.pctOnePlusHR >= 65.00 ? 'rgba(0, 105, 0)' : (trend?.pctOnePlusHR <= 50.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                                }
                                const loss_styles = {
                                    color: (trend?.pctLoss >= 50.00 ? 'rgba(0, 105, 0)' : (trend?.pctLoss <= 40.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                                }

                                return (
                                    <tr key={trend.id}>
                                        <td id="pitcherNameTD" onClick={() => navigateToPitcherPage(trend.name, trend.pitcherID)}>{trend.name}</td>
                                        <td style={teamStyles}>{trend.team}</td>
                                        <td style={trend.backgroundColor}>{trend.matchupRating}</td>
                                        <td>{trend.numberGames}</td>
                                        <td style={five_or_less_ip_styles}>{trend.pctFiveOrLessIP}%</td>
                                        <td style={six_or_less_ip_styles}>{trend.pctSixOrLessIP}%</td>
                                        <td style={four_or_less_strikeouts_styles}>{trend.pctFourOrLessK}%</td>
                                        <td style={five_or_less_strikeouts_styles}>{trend.pctFiveOrLessK}%</td>
                                        <td style={six_or_less_strikeouts_styles}>{trend.pctSixOrLessK}%</td>
                                        <td style={seven_or_less_strikeouts_styles}>{trend.pctSevenorLessK}%</td>
                                        <td style={eight_or_less_strikeouts_styles}>{trend.pctEightorLessK}%</td>
                                        <td style={two_plus_earned_runs_styles}>{trend.pctTwoPlusER}%</td>
                                        <td style={three_plus_earned_runs_styles}>{trend.pctThreePlusER}%</td>
                                        <td style={four_plus_earned_runs_styles}>{trend.pctFourPlusER}%</td>
                                        <td style={four_plus_hits_styles}>{trend.pctFourPlusHits}%</td>
                                        <td style={five_plus_hits_styles}>{trend.pctFivePlusHits}%</td>
                                        <td style={six_plus_hits_styles}>{trend.pctSixPlusHits}%</td>
                                        <td style={one_plus_walks_styles}>{trend.PctOnePlusWalks}%</td>
                                        <td style={two_plus_walks_styles}>{trend.pctTwoPlusWalks}%</td>
                                        <td style={one_plus_homer_styles}>{trend.pctOnePlusHR}%</td>
                                        <td style={loss_styles}>{trend.pctLoss}%</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                </table>
                </div>
            </div>)}
        </div>
    )
}

export default BadPitcherMatchupRatingTrendsTable